import { useCallback } from "react";
import { queries } from "../../shared/queries";
import type { SpaceMode } from "../../shared/schema";
import { displaySpaceName } from "../../shared/spaceName";
import { useQuery } from "@rocicorp/zero/react";

type Grant = {
  user?: { name: string | null } | null;
} & Record<string, unknown>;

export type DisplayableSpace = {
  id: string;
  name: string;
  mode: SpaceMode;
  roleGrantsAsScope?: readonly Grant[];
};

function ownerName(space: DisplayableSpace): string | null {
  return space.roleGrantsAsScope?.[0]?.user?.name ?? null;
}

export function useSpaceDisplayName(): (
  space: DisplayableSpace,
  overrideOwnerName?: string | null
) => string {
  const [personalSpace] = useQuery(queries.personalSpace());
  const viewerPersonalSpaceId = personalSpace?.id ?? null;
  return useCallback(
    (space: DisplayableSpace, overrideOwnerName?: string | null) => {
      const owner =
        space.mode === "personal"
          ? (overrideOwnerName ?? ownerName(space))
          : null;
      return displaySpaceName(space, viewerPersonalSpaceId, owner);
    },
    [viewerPersonalSpaceId]
  );
}
